import Axios from 'axios';
import Emitter from '../services/eventEmmiter/EventEmmiter';
import { EventTypes } from '../services/eventEmmiter/EventTypes';
import { IEndUserModel } from '../services/accountService/IEndUserModel';
import * as shared from '../styledApplication/style.css';
import SearchBar from './searchBar/SearchBar';
import * as style from './style.css';
import { Link } from 'react-router-dom';
import classes from '../framework/framework/tools/classes';
import HamburgerIcon from '../framework/framework/shared/icons/HamburgerIcon';
import BasketMenuItem from './basket/BasketMenuItem';
import React = require('react');

interface IProps {
    uriBuilder: (uir: string) => string;
    taxonomyId?: number;
    appName: string;
}

interface IState {
    userData: IEndUserModel;
    menuBarOpen: boolean;

}

export default class MenuBar extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            userData: null,
            menuBarOpen: false
        };
    }

    axios = Axios;

    componentDidMount() {
        Emitter.on(EventTypes.UserData, (data: IEndUserModel) => {
            this.setState({ userData: data });
        });
    }

    render() {
        return (
            <div className={classes(style.menuContainer, shared.withShadow)}>
                <nav className={classes(style.menuBar, style.menu1)}>
                    <div className={style.menuWrapper}>

                        <div className={style.brandName}>
                            <a href={this.props.uriBuilder('')}>
                                APC Prodent
                                <img src={this.props.uriBuilder('assets/za1.png')}></img>
                            </a>
                        </div>
                        <div className={style.xlOnly}>
                            <SearchBar uriBuilder={this.props.uriBuilder} />
                        </div>

                        <div className={classes(style.homeLink, style.xlOnly)}>
                            <a href={'https://www.apcprodent.pl'}>
                                www.apcprodent.pl
                            </a>
                        </div>
                    </div>
                </nav>
                <nav className={classes(style.menuBar, style.menu2)}>
                    <div className={classes(style.navbarLinks, this.state.menuBarOpen ? style.responsive : '')} >
                        <ul>
                            <li className={classes(style.actionElem, style.noHover)}>
                                <SearchBar uriBuilder={this.props.uriBuilder} />
                            </li>

                            <li key={'catalog'} onClick={() => this.setState({ menuBarOpen: false })}>
                                <Link to={'/Katalog'}>
                                    {'Katalog'}
                                </Link>
                            </li>
                            <li key={'promo'} onClick={() => this.setState({ menuBarOpen: false })}>
                                <Link to={'/promocje'}>
                                    {'Promocje'}
                                </Link>
                            </li>
                            <li key={'basket'} onClick={() => this.setState({ menuBarOpen: false })}>
                                <Link to={'/koszyk'}>Koszyk</Link>
                                <BasketMenuItem
                                    basketUri={this.props.uriBuilder('koszyk')}
                                    productUri={this.props.uriBuilder('produkty')}
                                ></BasketMenuItem>
                            </li>

                            <li className={classes(style.actionElem, style.noHover)}>
                                <div className={classes(style.homeLink)}>
                                    <a href={'https://www.apcprodent.pl'}>
                                        www.apcprodent.pl
                                    </a>
                                </div>
                            </li>

                            <li className={style.icon} onClick={() => this.onHamburgerClick()}>
                                <HamburgerIcon />
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        );
    }

    onHamburgerClick(): void {
        const isOpen = this.state.menuBarOpen;
        this.setState({ menuBarOpen: !isOpen });
    }
}
